import { Num } from '../rocket';

interface UtilPromiseEachFn<A> {
  (value: A): Promise<void>;
}

export class Util {
  static isPromise(promise): boolean {
    return (
         typeof promise === 'object'
      && typeof promise.then === 'function'
      && promise instanceof Promise
      && Promise.resolve(promise) === promise
    );
  }

  static promiseEach<A>(array: A[], fn: UtilPromiseEachFn<A>): Promise<void> {
    if (array.length === 0) {
      return Promise.resolve();
    }

    return array.reduce(
      (previous: Promise<void>, current: A) => previous.then(() => fn(current)),

      Promise.resolve(),
    );
  }

  static cycleArrayNext<A>(array: A[]): Function {
    let index = -1;

    return function () {
      index++;

      if (index > array.length - 1) {
        index = 0;
      }

      return array[index];
    };
  }

  static cycleArray<A>(array: A[], offset: number): A {
    const index = offset % array.length;

    return array[index];
  }

  static randomChoice<A>(array: A[]): A {
    const index = Num.random(array.length - 1, true);

    return array[index];
  }

  // Returns a debouncer function that no matter the frequency of calls
  // will only be invoked after the given delay timeout (in seconds).
  static debounce(delay: number, fn: Function): Function {
    let timeout;

    return function() {
      clearTimeout(timeout);

      timeout = setTimeout(
        () => fn.apply(this, arguments),
        delay * 1000
      );
    };
  }

  static throttle(threshold: number, fn: Function): Function {
    let timeout, last;

    threshold *= 1000;

    return function() {
      const now = Date.now();

      if (typeof last === 'number' && now < last + threshold) {
        clearTimeout(timeout);

        timeout = setTimeout(
          () => {
            last = now;
            fn.apply(this, arguments);
          },
          threshold
        );
      } else {
        last = now;

        fn.apply(this, arguments);
      }
    };
  }
}
